import { render, staticRenderFns } from "./service_mobile_nav.vue?vue&type=template&id=d22587fa&scoped=true"
import script from "./service_mobile_nav.vue?vue&type=script&lang=js"
export * from "./service_mobile_nav.vue?vue&type=script&lang=js"
import style0 from "./service_mobile_nav.vue?vue&type=style&index=0&id=d22587fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22587fa",
  null
  
)

export default component.exports